import type {
  OnboardingWizardStep,
  QuizAnswers,
  QuizProgressStep,
} from "@/src/components/OnboardingWizard/types";

const AGE_IDS = new Set(["18-24", "25-34", "35-44", "45-54", "55+"]);
const RISK_IDS = new Set(["safe", "balanced", "growth"]);

const QUIZ_GATE_STEPS: {
  step: QuizProgressStep;
  isComplete: (answers: QuizAnswers) => boolean;
}[] = [
  { step: "quiz/name", isComplete: (a) => a.name.trim().length > 0 },
  { step: "quiz/age", isComplete: (a) => AGE_IDS.has(a.age) },
  { step: "quiz/income", isComplete: (a) => a.income > 0 },
  { step: "quiz/expenses", isComplete: (a) => a.expenses > 0 },
  { step: "quiz/cash", isComplete: (a) => a.cash > 0 },
  { step: "quiz/debt", isComplete: (a) => a.debt >= 0 },
  { step: "quiz/invest", isComplete: (a) => a.invest > 0 },
  { step: "quiz/risk", isComplete: (a) => RISK_IDS.has(a.risk) },
];

/** First quiz step that must be completed before goal scoring (PRD §4.1). */
export const getFirstIncompleteQuizStep = (
  answers: QuizAnswers,
): QuizProgressStep | null => {
  for (const gate of QUIZ_GATE_STEPS) {
    if (!gate.isComplete(answers)) {
      return gate.step;
    }
  }
  return null;
};

export const isQuizAnswersReadyForGoalScoring = (
  answers: QuizAnswers,
): boolean => getFirstIncompleteQuizStep(answers) === null;

export const resolveGoalStepOrQuizRedirect = (
  step: OnboardingWizardStep,
  answers: QuizAnswers,
): OnboardingWizardStep => {
  if (step !== "goal") {
    return step;
  }
  return getFirstIncompleteQuizStep(answers) ?? step;
};
